import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const mobileDatePicker: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'mobui_MobuiDatePicker_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'MobuiDatePickerRole',
      bindings: [
        {
          title: 'mobui_MobuiDatePicker_dataBinding_value_label',
          prop: 'value',
          supportedFieldTypes: [FieldType.date, FieldType.dateTime],
          defaultFieldType: FieldType.dateTime,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
